import { Card, Input } from '@casumo/dojo-react';
import classNames from 'classnames';
import { FC, memo } from 'react';
import TrustlyIcon from './icons/TrustlyIcon';
import type { PnpCashierContent } from './pnpCashier.types';
import SuggestedAmounts from './PnpCashierSuggestionAmountContainer';
import { TEST_ID } from '../../utils/constants';

type PnpCashierViewProps = {
  content: PnpCashierContent;
  amount: string;
  error: string | null;
  currencySymbol: string;
  onAmountChange: (value: string) => void;
  onSelectAmount: (value: number) => void;
  onBlur: () => void;
};

const PnpCashierView: FC<PnpCashierViewProps> = ({
  content,
  amount,
  error,
  currencySymbol,
  onAmountChange,
  onSelectAmount,
  onBlur,
}) => (
  <>
    <Card
      data-testid={TEST_ID.PNP + 'cashier-card'}
      title={content.title}
      description={content.description}
      className={classNames('bg-white flex flex-col',
        '[&_[data-testid=card-header]]:p-sm tablet:[&_[data-testid=card-header]]:p-md',
        '[&_[data-testid=card-content]]:px-sm [&_[data-testid=card-content]]:pb-sm',
        'tablet:[&_[data-testid=card-content]]:px-md tablet:[&_[data-testid=card-content]]:pb-md',
      )}
    >
      <div className="flex flex-col gap-xs">
        <SuggestedAmounts
          amounts={content.suggestedAmounts}
          selectedAmount={amount}
          currencySymbol={currencySymbol}
          onSelect={onSelectAmount}
        />

        <Input
          id="pnp-amount-input-field"
          name="pnp-amount-input-field"
          data-testid={TEST_ID.INPUT + 'pnp-amount'}
          label={content.placeholder}
          placeholder={content.placeholder}
          inputMode="numeric"
          value={amount ? `${currencySymbol}${amount}` : ''}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            onAmountChange(e.target.value)
          }
          onBlur={onBlur}
          error={!!error}
          errorMessage={error || undefined}
          inputClassName={error ? 'text-red-40' : undefined}
          wrapperClass="!pr-2xs !h-2xl"
          sufix={
            <div className="bg-white rounded-sm px-3.5 py-1.5
              flex items-center justify-center"
            >
              <TrustlyIcon />
            </div>
          }
        />
      </div>
    </Card>

    <p
      className="text-grey-50 text-2xs px-2xs"
      data-testid={TEST_ID.PNP + 'cashier-terms'}
      dangerouslySetInnerHTML={{ __html: content.termsText }}
    />
  </>
);

export default memo(PnpCashierView);
